export const API_URL = 'https://admin-api.vesomayman.vn';
export default API_URL;
